<div *ngIf="!loader" fxLayout="column" class="layout-padd" fxFlexFill [ngStyle]="{'max-height.px': innerHeight}">

    



    <div fxLayout="row" fxLayoutAlign="end end">

        <div>
            <button mat-icon-button class="dark-ico" (click)="openUsercontrol()">
                <mat-icon>security</mat-icon>
            </button>

          
        </div>
    </div>




    <div fxLayout="column" fxFlexFill fxLayoutGap="25px">

        <!-- Logo tpe -->
        <div fxFlex="50%" fxLayoutAlign="center center">
            <img *ngIf="!$error &&statusMessage.status==0 || statusMessage.status==1" src="assets/img/icons/TPE.png"
                style="height: 200px; width: auto;">
            <img *ngIf="!$error && statusMessage.status==2" src="assets/img/icons/green.png" style="height: 200px; width: auto;">
            <img *ngIf="$error || statusMessage.status==-1" src="assets/img/icons/red.png" style="height: 200px; width: auto;">
        </div>


        <!-- message -->
        <div fxFlex>

            <div fxLayout="column" fxFlexFill>

                <div fxFlex="80%" class="text-center">
                    <span *ngIf="!$error && statusMessage " class="mat-title boldest spacingword"
                        [innerHTML]="'payIntent.'+ statusMessage.mess|translate">
                    </span>
                    <span *ngIf="$error" class="mat-title boldest spacingword"
                        [innerHTML]="'payIntent.error'|translate">
                    </span>

                </div>


                <div fxLayout="row" fxLayoutAlign="center center">
                    <div style="width: 50%;">
                        <mat-progress-bar class="myprogress-bar "
                            [ngClass]="$error?'red': statusMessage.color?statusMessage.color:'grey'" mode="indeterminate">
                        </mat-progress-bar>

                    </div>
                </div>

            </div>
        </div>
    </div>






</div>